import React,{useRef, useState} from "react";
import BtnSubmit from "../../../../Shared/Buttons/BtnSubmit";
import  OptionInput  from "../optionInput/OptionInput";
import  Option from "../option/Option";
import { connect } from "react-redux";
import {optionsPageDetails} from '../constants';
import PopUp from '../../../../Shared/Popup/PopUp';
import {OptionPopUp} from '../optionPopUp/OptionPopUp';
import hey from '../images/hey.svg';
import {GeneralPurposeMagicLink,setProgramCurrentStep} from '../../familyMemberCellularSaleSlice';
import {OPTION_INPUT_TYPES,PROGRAM_STEPS} from '../enums'
import {getOrganizationFamilyPackagesData} from '../../../WelcomeBlock/welcomeBlockSlice';
import {showAppLoader, hideAppLoader} from '../../../../Shared/Loader/LoaderSlice';
import EpiContext from '@episerver/spa-core/Spa';
import { dwhDictionary,dwhReport } from '../../../IdfSaleBlock/dwhReports/dwhGeneralReport';

const OrgFamilyMembersSaleMainPage = (props) => {

  const [showPopUp, setShow] = useState(false);
  const InputRef=useRef();
  const selectedOptionValue=props.store.optionsData["option"+props.store.selected] ?? {};

  const transferLinePopUps={
    cellcomLinePopUp:{
      icon:hey,
      changePlanPageLink:props.iContent?.changePlanPageLink?.value,
      heading:`שמנו לב שקו מספר ${selectedOptionValue.input} כבר קיים ב${window.Config.brand_Name_HE} `,
      secondaryHeading:"האם לשנות לתוכנית בני משפחות?",
      buttonText:"כן אני רוצה לשנות תכנית",
      footerText:"חזרה לתפריט ראשי",
      footerTextClicked:()=>setShow(false),
    }
  }

  const btnNotReadyForAction=()=>{
    const errorInNiudOption=props.store.selectedType===OPTION_INPUT_TYPES.TRANSFER_LINE && props.store.optionInputError!=="";
    return props.store.selectedType==="" || errorInNiudOption;
  }

  const checkMlResponseAndRedirect=(res)=>{
    if(res?.payload?.Header?.ReturnCode=='0'){
      props.setProgramCurrentStep(PROGRAM_STEPS.TRANSFER_LINE_SUCCESS);
    }
    else{
      props.setProgramCurrentStep(PROGRAM_STEPS.TRANSFER_LINE_ML_FAILURE);
    }
  }

  const programRouter=async()=>{
    dwhReport(dwhDictionary.IDFFamilyMember_SelectionLine_Ongoing);
    const selectedType=props.store.selectedType;

    switch (selectedType) {
      case OPTION_INPUT_TYPES.NEW_LINE:{
        props.setProgramCurrentStep(PROGRAM_STEPS.NEW_LINE_SHOW_SALE_PACKAGES);
        break;
      }
      case OPTION_INPUT_TYPES.TRANSFER_LINE:{
        if (!selectedOptionValue?.isCellcomNum) {
          if (props.store.optionInputError === "" && selectedOptionValue?.input) {
            props.showAppLoader();
            await props.getOrganizationFamilyPackagesData();
            props.hideAppLoader();
            if (props.welcomeStore.familyPackagesData?.isAllowed) {
              const objForMagicLink = {
                clientName: "CELLCOM_WEB_SITE",
                scopeName: "SALEFAMILYNPQ",
                isDynamic: true,
                sendSms: true,
                sendEmail: false,
                parameters: {
                  employCli: props.contactNumber,
                  orgNumber: props.orgId,
                  phoneNumber: selectedOptionValue?.input,
                  otpPhone: '',
                  contactName: props.firstName,
                  returnUrl: props.iContent?.magicLinkReturnUrl?.value,
                }
              }
              const res=await props.GeneralPurposeMagicLink(objForMagicLink);
              checkMlResponseAndRedirect(res);
            } else {
              props.setProgramCurrentStep(PROGRAM_STEPS.TRANSFER_LINE_CAPACITY_FAILURE);
            }
          }
        } else if (selectedOptionValue?.isCellcomNum) {
          setShow(true);
        }
        break;
      }
      case OPTION_INPUT_TYPES.CHANGE_PACKAGE:{
        EpiContext.navigateTo(transferLinePopUps.cellcomLinePopUp.changePlanPageLink);
        break;
      }
      default:{
        break;
      }
    }
  }

  return (
    <div className="idf-family-members-sale">
      <div className="main-title">
        <pre className="customize-main-title">
        {optionsPageDetails.mainHeading.replace("CUSTOMER_NAME",props.firstName ?? "לקוח")}
        </pre>
      </div>
      <div className="secondary-title">
        {optionsPageDetails.secondaryHeading}
      </div>
      <div className="options-list-wrapper">
        {optionsPageDetails.options.map((val, key) => {
          return (
            <div key={key}>
              <Option val={val} optionKey={key}/>
              <OptionInput
               ref={InputRef}
               currentOption={val}
               optionInputKey={key}/>
            </div>
          );
        })}
      </div>
        <PopUp showPopUp={showPopUp} onClose={() => setShow(false)}>
          <OptionPopUp popUpObj={transferLinePopUps.cellcomLinePopUp}
          onBtnClick={()=>{
            EpiContext.navigateTo(transferLinePopUps.cellcomLinePopUp.changePlanPageLink)
            }} />
        </PopUp>
      <div className="button-wrapper">
        <BtnSubmit
          className={btnNotReadyForAction()?"grayBtn":""}
          text={optionsPageDetails.buttonText}
          onclick={async()=>{
            if(!btnNotReadyForAction()){
              await programRouter();
            }
          }}/>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.familyMemberCellularSale,
    authentication:state.authentication,
    welcomeStore:state.welcomeBlock,
    orgId:state.selfcarePage?.orgId,
    firstName:state.authentication?.loginData?.userDetails?.firstName,
    contactNumber:state.authentication?.loginData?.userDetails?.contactNumber,
    accountSegment:state.selfcarePage?.organizationState?.createAccountSegment?.expandedValue?.[0],
  };
};

const mapDispatchToProps ={
  getOrganizationFamilyPackagesData,
  showAppLoader,
  hideAppLoader,
  setProgramCurrentStep,
  GeneralPurposeMagicLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgFamilyMembersSaleMainPage);
